<template>
  <div class="picmanagetable">
    <el-table :data="tableData"
              style="width: 100%;padding:10px 10px 0 10px;"
              border>
      <el-table-column prop="createAtMY"
                       label="创建日期"
                       width="300">
        <!-- <template slot-scope="scope">
          <span>{{formatConversion(scope.row.createAt)}}</span>
        </template> -->
      </el-table-column>
      <el-table-column prop="name"
                       label="标签分类名称">
      </el-table-column>
      <el-table-column prop="labelNumber"
                       label="标签个数">
        <template slot-scope="scope">
          <span style="color: #5b9bd1;cursor: pointer;"
                @click="openDialog(scope.row)">{{scope.row.labelNumber}}</span>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="status"
                      width="80"
                       label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1">
            <el-tag type="success">{{'开启'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 0">
            <el-tag type="danger">{{'停用'}}</el-tag>
          </div>

          <div v-if="scope.row.status !== 0 && scope.row.status !== 1">
            <el-tag type="info">{{'无'}}</el-tag>
          </div>
        </template>
      </el-table-column> -->

      <el-table-column label="操作"
                       width="320">
        <template slot-scope="scope">
          <!-- <el-button @click="changeClick(scope)"
                     style="color:#185ED3;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-edit-outline"></i>修改</el-button>
          <span style="margin:0 11px;"> | </span> -->
          <el-button @click="removeClick(scope)"
                     style="color:#F96900;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-circle-close"></i>删除</el-button>
          <!-- <span style="margin:0 11px;"> | </span>
          <el-button @click="removeClick(scope)" style="color:#FF4545;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-delete"></i>删除</el-button> -->
        </template>
      </el-table-column>

    </el-table>

    <mydialog @dialogSubmit="dialogSubmit"
              :title="title"
              :myform="myform"
              :label="label"
              :dialogFormVisible="dialogFormVisible"></mydialog>
    


    <el-dialog :visible.sync="dialogVisible"
               width="38%"
               :before-close="handleClose">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>查看标签列表</div>
      </div>
      <el-table ref="multipleTable"
                :data="labelList"
                v-loading="tableLoading"
                style="width: 100%;padding:10px 10px 0 10px;margin-bottom:20px;height:300px;overflow-y: auto;"
                border>
        <el-table-column prop="createAtMY"
                       label="创建日期">
        </el-table-column>
        <el-table-column prop="labelName"
                        label="标签名称">
        </el-table-column>

      </el-table>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dialog } from '@/components/index'
import { mapActions } from 'vuex'
import { getLabel,list } from "@/api/customLabel";

import { formatConversion } from "@/plugins/getdate";
export default {
  name: 'picmanagetable',
  props: {
    tableData: Array,
  },
  components: {
    'mydialog': dialog
  },

  watch: {
    '$store.state.user.dialogFormVisible' (data) {
      this.dialogFormVisible = data
    },
    'myform' (data) {
      this.myform = data
      console.log(this.myform)
    },
  },


  data () {
    return {
      label: ['分类名称', '排序'],
      title: '修改标签分类',
      myform: {},
      dialogFormVisible: this.$store.state.user.dialogFormVisible,
      changeData: [],
      dataIndex: 0,  //需要改变table的索引
      className:'',
      labelList:[],
      dialogVisible: false,
      tableLoading:false,
      // tableData:[
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'52个',
      //     pics:'630张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'人文图片库',
      //     picj:'5个',
      //     pics:'30张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'0个',
      //     pics:'0张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'1234个',
      //     pics:'95487张',
      //   },
      // ]
    }
  },
  methods: {
    ...mapActions(["setDialogFormVisible"]),
    changeClick (scope) {
      this.myform = {
        one: scope.row.name,
        two: scope.row.sort
      }
      // this.getLibAsync(scope.row.name)
      this.setDialogFormVisible(true)

    },
    //删除图片库
    removeClick (scope) {

      this.$emit('removeClick', scope)

    },
    //接受dialog组件提交之后传递过来的值
    dialogSubmit (data) {
      this.$emit('formSubmit', data)
    },


    openDialog (data) {
      this.className = data.name
      this.dialogVisible = true

      this.labelListAsync({
        page:0,pageSize:100,className:this.className
      })
    },
    handleClose () {
      this.dialogVisible = false
      this.className = ''
      this.labelList = []
    },


    async labelListAsync (val) {
      this.tableLoading = true
      let { status, data, message, pagination, errors } = await list(val);
      if (status) {
        this.labelList = data;

        for (let i = 0; i < this.labelList.length; i++) {
          this.labelList[i].createAtMY = formatConversion(this.labelList[i].createAt.toString())
        }
        this.tableLoading = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.tableLoading = false
      }
    },


    //查询图片库
    async getLibAsync (val) {
      let { status, data, message, errors } = await getLabel(val);
      if (status) {
        this.myform = {
          one: data.name,
          two: data.sort,
          ...data
        }
        // console.log(this.myform)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
  },
  created () {

  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.btn:hover {
  text-decoration: underline;
}
</style>
